import getStore from 'services/getStore';
import getCurrentTopic from 'services/apiHelpers/getCurrentTopic';
import { getBlock, getInteractionsFromTopicAndState } from 'selectors/block';

export default (topic = null) => {
  const state = getStore().getState();
  const block = getBlock(state.blocks, topic ? topic.id : getCurrentTopic().id);
  const interactions = getInteractionsFromTopicAndState(state, block);

  return interactions;
};
